export default __webpack_public_path__ + "static/media/app-store.04a01475.svg";